import React, { type ReactNode } from 'react'

import { BaseContent, Dropdown, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'

import * as S from './CredentialList.styled'

export type CredentialListProps = {
  items: {
    id: string
    name: string
    description: ReactNode
  }[]
  onDelete?: (id: string) => void
}

export const CredentialList = ({ items, onDelete }: CredentialListProps) => (
  <S.Container>
    <ul>
      {items.map((item) => (
        <S.Item key={item.id}>
          <div>
            <BaseContent>{item.name}</BaseContent>
            <BaseContent appearance="secondary" size="small">
              {item.description}
            </BaseContent>
          </div>
          {onDelete && (
            <div>
              <Dropdown
                content={<Dropdown.Item label="Delete" onClick={() => onDelete(item.id)} />}
              >
                <ToolbarButton icon={DotsHorizontalIcon} size="small" />
              </Dropdown>
            </div>
          )}
        </S.Item>
      ))}
    </ul>
  </S.Container>
)
